import styled from 'styled-components';

export const Button = styled.div`
  position: fixed;
  z-index: 4;
  bottom: 28px;
  right: 28px;
  height: 48px;
  width: 48px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0px 8px 18px rgba(57, 78, 127, 0.2);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;
